import { makeStyles, withStyles } from '@material-ui/core/styles'
import { Tabs, Tab } from '@material-ui/core'
export const StyledTabs = withStyles((theme) => ({
  root: {
    padding: '8px 0',
  },
  indicator: {
    bottom: '6px',
    backgroundColor: (props) => (props.bgColor ? props.bgColor : '#4A4A4A'),
    height: 4,
  },
}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />)

export const StyledTab = withStyles((theme) => ({
  root: {
    minWidth: 72,
    minHeight: 36,
    fontFamily: 'Montserrat, Avenir, "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif',
    fontSize: '1.125rem',
    lineHeight: '1.5rem',
    marginRight: theme.spacing(2),
    color: '#FFFFFF',
    '&:hover': {
      color: '#FFFFFF',
      opacity: 1,
    },
    '&$selected': {
      color: '#FFFFFF',
      fontWeight: 500,
    },
    '&:focus': {
      color: '#FFFFFF',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />)

const useStyles = makeStyles((theme) => ({
  page:{
    minHeight: '100vh',
    backgroundImage: "url('https://tm-public-file.s3.ap-southeast-1.amazonaws.com/ylp-bg-site.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    fontFamily: 'Montserrat, Avenir, "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif',
  },
  root: {
    minHeight: '100vh',
    paddingBottom: 48,
    backgroundImage: `url("/syops.jpg")`,
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 24,
    },
  },
  paper: {
    padding: 24,
    color: '#4A4A4A',
    backgroundColor: '#3BBBE6',
    borderRadius: 5,
    boxShadow: '0 0 10px 0 rgba(155, 155, 155, 0.3)',
  },
  navbar: {
    padding: '0',
    display: 'flex',
    padding: '16px 0',
    // height: '152px',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  logoSite: {
    minWidth: '100px',
    maxWidth: '136px',
    maxHeight: '136px',
  },
  headerText: {
    marginBottom: '8px',
    paddingBottom: '4px',
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: '2rem',
    textTransform: 'uppercase',
    color: '#FFFFFF',
    borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
  },
  img: {
    width: '100%',
    borderRadius: 5,
  },
  description: {
    color: ('#FFFFFF'),
    '& p': {
      '&:first-child': {
        margin: 0,
      },
    },
    '& strong': {
      fontWeight: 600,
    },
    [theme.breakpoints.down('sm')]: {
      padding: '24px 16px',
      '& img': {
        width: '100% !important',
      },
    },
  },
  containerNotEntry:{
    position: 'relative',
    top: '-48px'
  }
}))

export default useStyles
